export default "__VITE_ASSET__a9c2a2a7__"